import React from 'react'
import { getSizedImgUrl } from '@util'

export default ({
  src,
  width,
  height,
  style = {},
  mode,
  short,
  long,
  ...rest
}) => {
  if (style.width) {
    width = style.width
  }

  if (style.height) {
    height = style.height
  }

  return (
    <img
      src={getSizedImgUrl({ src, width, height, mode, short, long })}
      style={style}
      {...rest}
    />
  )
}
